import { Injectable } from '@angular/core';

import { ApiModel } from './api.model';

@Injectable()
export class UploadAuthorizationModel {
    constructor(private apiModel: ApiModel) {}

    getS3UploadAuthorization(contentType: string) {
        return this.apiModel.makeHttpRequest({
            method: 'POST',
            url: `${this.apiModel.getUploadsEndpoint()}/signS3`,
            body: {
                contentType
            }
        });
    }
}
